export default __webpack_public_path__ + "static/media/landingBg4.55b2d48e.png";